import React from 'react';
import { CountryType } from 'components/registry/components/CountryType/CountryType';
import { ActivityLocationDTO } from 'types/types';

type LocationsListProps = {
  locations: ActivityLocationDTO[];
};

export const LocationsList = ({ locations }: LocationsListProps) => (
  <>
    {locations.length
      ? locations.map((location) => (
          <div key={location.id} style={{ marginBottom: '4px' }}>
            <CountryType isResident={location.resident === true || location.resident === 'true'} />
            <span style={{ marginLeft: '8px' }}>
              {[location.activityLocationName, location.activityLocationAddress]
                .filter(Boolean)
                .join(', ')}
            </span>
          </div>
        ))
      : 'Нет информации о площадках'}
  </>
);
